import { Search } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { seoContent } from "@/data/eventOrganizerContent";

const SeoCopySection = () => {
  return (
    <section id="seo-summary" data-testid="seo-summary-section" className="py-10">
      <Card data-testid="seo-summary-card" className="border-fuchsia-200 bg-violet-50/75">
        <CardContent className="space-y-3 p-5 md:p-6">
          <p
            data-testid="seo-summary-eyebrow-text"
            className="inline-flex items-center gap-2 rounded-full border border-fuchsia-200 bg-fuchsia-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-fuchsia-700"
          >
            <Search className="h-3.5 w-3.5" />
            Regional Search Summary
          </p>
          <h2 data-testid="seo-summary-heading" className="text-2xl leading-tight text-violet-950 md:text-3xl">
            {seoContent.heading}
          </h2>
          <p data-testid="seo-summary-body" className="text-sm leading-relaxed text-violet-900/85 md:text-base">
            {seoContent.body}
          </p>
        </CardContent>
      </Card>
    </section>
  );
};

export default SeoCopySection;